module.exports = __webpack_public_path__ + "img/198coupon.d2a696db.png";